// extracted by mini-css-extract-plugin
module.exports = {"container":"app-download_container__Df7Ns","link":"app-download_link__3H_m1","google_icon":"app-download_google_icon__MxIzT"};